/**
 * Determines car availability status based on model status
 * @param status - The model status from modelDetails
 * @returns car_availability value for event tracking
 */
export const getCarAvailability = (status?: string): string => {
  if (status === "out_of_production") {
    return "Discontinued";
  }
  if (status === "non_sellable") {
    return "No";
  }
  return "Yes";
};

export const getCarAvailabilityOldFlow = (status?: string): string => {
  const normalizedStatus = status?.toLowerCase();

  if (
    normalizedStatus === "out of production" ||
    normalizedStatus === "out_of_production"
  ) {
    return "Discontinued";
  }
  if (normalizedStatus === "on sale" || normalizedStatus === "sellable") {
    return "Yes";
  }
  return "No";
};
